import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideConfiguratorMoreProductInfoPopUp } from '../../Actions/Configurator/Configurator.action';
import Popup from 'reactjs-popup';
import { translate } from '../../Services/translation';
const ConfiguratorMoreProductInfoPopUp = () => {
    const dispatch = useDispatch();
    const { showConfiguratorMoreProductInfoPopUp, productUrl } = useSelector((state) => state.productConfigurator);  
    const hide = () => {
        dispatch(hideConfiguratorMoreProductInfoPopUp());
    }
    const openProductUrlBlank = () => {
        window.open(productUrl, '_blank');
        hide();
    };

    const styles = {
        wrapper: {
            textAlign: 'center'
        },
        content: {
            display: 'flex',
            justifyContent: 'center'
        },
        paragraph: {
            maxWidth: '80%'
        },
        buttons: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '0.5rem'
        },
        btnContinue: {
            background: 'none'
        }
    };

    return <Fragment>
        {showConfiguratorMoreProductInfoPopUp && <Popup
                open={true}
                closeOnDocumentClick={false}
            >
                <div className="more-product-info">
                    <div className="modal">                       
                        <div className="content" style={styles.wrapper}>
                            <h3 className="more-product-info__title">
                                {translate("configuratorMoreProductInfoPopUpTitle")}
                            </h3>
                            <div className="more-product-info__content" style={styles.content}>
                                <p style={styles.paragraph}>
                                    {translate("configuratorMoreProductInfoPopUpContent")}
                                </p>
                            </div>
                            <div className="more-product-info__buttons" style={styles.buttons}>
                                <button className="button button--ghost" onClick={() => hide()}>{translate("configuratorMoreProductInfoPopUpBtnAbort")}</button>
                                <button className="button button--buy-button" style={styles.btnContinue} onClick={() => openProductUrlBlank()}>{translate("configuratorMoreProductInfoPopUpBtnContinue")}</button>
                            </div>                            
                        </div>
                    </div>
                </div>
            </Popup>}
    </Fragment>
}
export default ConfiguratorMoreProductInfoPopUp;